module.exports = __webpack_public_path__ + "static/img/ikonaStepbystep-OFF.9798ac90.png";